import type { ReactNode } from 'react';
import { CheckCircle, Save } from 'lucide-react';

interface SubmissionModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  detail?: string;
  variant?: 'success' | 'draft';
  icon?: ReactNode;
}

export function SubmissionModal({
  isOpen, onClose, title, message, detail, variant = 'success', icon,
}: SubmissionModalProps) {
  if (!isOpen) return null;

  const colors = variant === 'draft'
    ? { bg: '#f1f5f9', icon: '#64748b', button: '#475569' }
    : { bg: '#dcfce7', icon: '#16a34a', button: '#2563eb' };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.7)',
      backdropFilter: 'blur(5px)',
      zIndex: 1000,
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      animation: 'fadeIn 0.3s ease-out',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '24px',
        padding: '40px',
        maxWidth: '420px',
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        animation: 'slideUp 0.3s ease-out',
      }}>
        <div style={{
          width: '72px', height: '72px',
          background: colors.bg,
          borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px',
        }}>
          {icon || (variant === 'draft'
            ? <Save size={36} color={colors.icon} />
            : <CheckCircle size={36} color={colors.icon} />
          )}
        </div>

        <h2 style={{ margin: '0 0 8px', fontSize: '1.4rem', fontWeight: 700, color: '#0f172a' }}>
          {title}
        </h2>

        <p style={{ margin: '0 0 24px', fontSize: '0.95rem', color: '#64748b', lineHeight: 1.5 }}>
          {message}
        </p>

        {detail && (
          <p style={{ margin: '0 0 28px', fontSize: '0.85rem', color: '#94a3b8' }}>
            {detail}
          </p>
        )}

        <button
          onClick={onClose}
          style={{
            padding: '14px 40px',
            background: colors.button,
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '1rem',
            fontWeight: 600,
            cursor: 'pointer',
            boxShadow: `0 4px 6px rgba(0,0,0,0.15)`,
          }}
        >
          Compris
        </button>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px) } to { opacity: 1; transform: translateY(0) } }
      `}</style>
    </div>
  );
}
